import fixDateTimezone from '../../../utils/fixDateTimezone';
import formatDate from '../../../utils/formatDate';

// Сторы отдают данные с задержкой 1–2 дня: отставание больше этого — пора загрузить свежие выгрузки.
export const STORE_LAG_DAYS = 3;

const time = (iso) => (iso ? formatDate(fixDateTimezone(iso), true) : '');
// 'YYYY-MM-DD' → 'DD.MM.YYYY' без часовых поясов
const day = (value) => (value ? value.slice(0, 10).split('-').reverse().join('.') : '');
const daysBetween = (from, to) => Math.round((Date.parse(to) - Date.parse(from)) / 86400000);

export const isBusy = (status) => status?.state === 'requested' || status?.state === 'running';

// Строка статуса обновления: что сейчас происходит или чем закончилось последнее
export const refreshSummary = (status) => {
  if (!status) return { text: 'Загрузка…', tone: 'muted' };
  if (status.state === 'requested') return { text: 'В очереди: обновление начнётся в течение минуты', tone: 'busy' };
  if (status.state === 'running') return { text: 'Идёт обновление, это около минуты…', tone: 'busy' };
  if (!status.finishedAt) return { text: 'Обновлений ещё не было', tone: 'muted' };
  if (status.ok) return { text: `Обновлено ${time(status.finishedAt)}`, tone: 'ok' };
  return { text: `Ошибка обновления ${time(status.finishedAt)}: ${status.message || 'причина неизвестна'}`, tone: 'error' };
};

// Источники установок: по какой день загружены данные. Сторы вносят вручную из CSV, AppsFlyer тянется сам.
// today — сегодняшний день 'YYYY-MM-DD' в Казахстане (параметр, чтобы проверять тестом).
export const sourceRows = (installs, today = fixDateTimezone().format('YYYY-MM-DD')) => {
  const last = (...keys) => keys.map((k) => installs?.[k]?.lastDay).filter(Boolean).sort().pop() || null;
  const rows = [
    { title: 'iOS — App Store Connect', lastDay: last('iosStore'), manual: true },
    { title: 'Android — Google Play', lastDay: last('androidStore'), manual: true },
    { title: 'AppsFlyer (iOS и Android)', lastDay: last('iosAppsflyer', 'androidAppsflyer'), manual: false },
  ];

  return rows.map((r) => ({
    title: r.title,
    lastDay: r.lastDay ? day(r.lastDay) : 'нет данных',
    stale: r.manual && (!r.lastDay || daysBetween(r.lastDay, today) > STORE_LAG_DAYS),
  }));
};

const PLATFORMS = { ios: 'iOS', android: 'Android' };

// Итог загрузки по каждому файлу: платформа и диапазон дат либо причина отказа
export const importLines = (files = []) =>
  files.map((f) =>
    f.ok
      ? { ok: true, text: `${f.name}: ${PLATFORMS[f.platform] || f.platform}, ${f.days} дн., ${day(f.from)} – ${day(f.to)}` }
      : { ok: false, text: `${f.name}: ${f.error}` }
  );

export const errorText = (error) =>
  error?.response?.data?.errorMessage || error?.response?.data?.message || error?.message || 'Неизвестная ошибка';

